import { render, staticRenderFns } from "./Role-Access.vue?vue&type=template&id=b34dad02&scoped=true"
import script from "./Role-Access.vue?vue&type=script&lang=js"
export * from "./Role-Access.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34dad02",
  null
  
)

export default component.exports